<template>
  <div class="home h-100">
    <!-- Navigation -->
    <CoralstoneUnitNavbar />
    <section class="unit-header">
        <div class="overlay-vantlead"></div>
        <div class="container">
            <div class="unit-wrapper">
                
                <div class="backBtn-wrapper">
                    <a @click="$router.push({ name: 'Home'})" href="#" class="btn">
                        <span class="fas fa-arrow-left"></span>
                        <span class="ml-2 back">Back</span>
                    </a>
                </div>
                    
                <div class="header-text-wrapper">
                    <div class="header-text">
                        <h1>Vantlead Tech</h1>
                        <p>Developing advanced technology tools and solutions</p>
                        <a href="#" class="btn btn-primary">Visit Website</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="who-we-are">
      <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="who-text">
                    <h3>Who are we?</h3>
                </div>
            </div>
            <div class="col-md-8">
                <div class="main-text">
                    <p>
                    As a technology-driven financial services group, we are heavily invested in developing advanced technology tools and solutions for our use, and we make the same available for other businesses; hence, VantLead Tech.
                    </p>
                    <p>VantLead Tech is our technology arm that focuses on developing highly functional digital solutions that empower businesses to serve their customers seamlessly and achieve their business goals faster.</p>
                    <p>The company's core services include web app development, mobile app development, as well as product ideation and design, all of which are delivered by a growing team of professional developers who are well-versed in building world-class applications.</p>
                    <p>VantLead Tech serves businesses that cut across various industries, and delivers unique software solutions to each business, fully optimised with features and capabilities that suit the client's industry and business goals.</p>
                </div>
            </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import CoralstoneUnitNavbar from "./CoralstoneUnitNavbar"

export default {
  name: 'Home',
  components: {
    CoralstoneUnitNavbar,
    Footer
  },
  
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .unit-header {
      position: relative;
      background: url('../../public/img/vantlead.jpg') no-repeat;
      background-size: cover;
      height: 600px;

      .overlay-vantlead {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #04ACEC;
        mix-blend-mode: normal;
        opacity: 0.9;
        }

        .unit-wrapper {
            position: relative;

            .backBtn-wrapper {
                position: absolute;
                top: 6rem; 
                left: 0;

               .back {
                    font-family: Source Sans Pro;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 20px;
                    color: #fff;
                }

                .fa-arrow-left {
                    color: #fff;
                }
            }

            .header-text-wrapper {
                position: absolute;
                top: 19rem;
                left: 0;

                .header-text {
                    h1 {
                   font-family: Inter, sans-serif;
                    font-style: normal;
                    font-weight: 800;
                    font-size: 62px; 
                   
                    }

                    h1, p {
                        color: #fff;
                    }

                    p {
                        font-family: Inter, sans-serif;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 24px;
                        line-height: 34px;
                        width: 50%;
                        letter-spacing: 0.02em;
                        width: 70%;
                    }

                    .btn-primary {
                        background-color: #2C3C90 !important;
                        border-color: #2C3C90 !important;
                        color: #fff;
                        font-family: Montserrat;
                        font-style: normal;
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.02em;
                        text-transform: uppercase;
                        border-radius: 8px;
                        padding: 0.6rem 1rem;

                        &:hover {
                            background-color: #3548a8 !important;
                            border-color: #3548a8 !important;
                        }

                        &:focus {
                            outline: none;
                            box-shadow: none !important;
                        }
                    }
                }

            }

        }
  }

  // who we are styles
  .who-we-are {
    padding: 4rem 0 6rem;

    .who-text {
        background: #04ACEC;
        padding-left: 1rem;
        border-bottom: 2px solid #94248C;

        h3 {
            font-family: Inter, sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 32px;
            line-height: 48px;
            letter-spacing: 0.02em;
            color: #fff;
        }
    }

    .main-text {
        p {
            font-family: Inter;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 23px;
           color: #28283A;
        }
    }

  }

  
//   @media (min-width: 992px) and (max-width: 1199px) {
//     .unit-header {

//     }
//     .who-we-are {

      
//     }
//   }

  @media (min-width: 767px) and (max-width: 991px) {
    .unit-header {
    
        .unit-wrapper {
            .header-text-wrapper {

                .header-text {
                    h1 {
                        font-size: 48px; 
                    }

                    p {
                        font-size: 22px;
                    }

                    .btn-primary {
                        font-size: 14px;
                    }
                }
            }
        }

    }
    .who-we-are {

        .who-text {
        
            h3 {
                font-size: 26px;
            }
        }

    }
  }

  @media (max-width: 767px) {
    .unit-header {
        .unit-wrapper {
            .header-text-wrapper {
                top: 15rem;

                .header-text {
                    text-align: center;
                    h1 {
                        font-size: 42px; 
                    }

                    p {
                        font-size: 20px;
                        width: 100%;
                    }

                    .btn-primary {
                        font-size: 14px;
                    }
                }
            }
        }

    }
    .who-we-are {

      .who-text {
        
            h3 {
                font-size: 26px;
                margin-bottom: 1rem;
            }
        }
    }
  }

  



</style>

